import React from 'react';
import { Row, Col, Typography, Layout } from 'antd';
import './LoginFooter.css';

const { Title, Link, Text } = Typography;
const { Footer } = Layout;

const footerData = [
  {
    title: 'SOLUTIONS',
    links: [
      { text: 'Recruiting Automation', url: 'https://gohire.com/recruiting-automation/' },
      { text: 'TCPA Compliance', url: 'https://gohire.com/text-recruiting-tcpa-compliance/' },
      { text: 'Chrome Extension', url: 'https://gohire.com/text-recruiting-chrome-extension/' },
    ],
  },
  {
    title: 'PRODUCTS',
    links: [
      { text: 'Text Recruiting', url: 'https://gohire.com/text-recruiting-software/' },
      { text: 'Apply-by-Text', url: 'https://gohire.com/apply-by-text/' },
      { text: 'Career Site Chatbots', url: 'https://gohire.com/career-site-chatbots-for-recruiting/' },
      { text: 'Automated Interview Scheduling', url: 'https://gohire.com/automated-interview-scheduling/' },
    ],
  },
  {
    title: 'RESOURCES',
    links: [
      { text: 'Recruiting Chatbot Use Cases', url: 'https://gohire.com/top-11-ways-to-use-a-recruiting-chatbot/' },
      { text: 'Recruiting AI FAQS', url: 'https://gohire.com/recruiting-chatbot-faqs/' },
      { text: 'GoHire Talks Podcast', url: 'https://gohire.com/gohire-talks/' },
    ],
  },
  {
    title: 'COMPANY',
    links: [
      { text: 'About Us', url: 'https://gohire.com/about-us/' },
      { text: 'Contact Us', url: 'https://gohire.com/contact-us/' },
      { text: 'Request a Sales Demo', url: 'https://gohire.com/recruiting-chatbot-demo/' },
    ],
  },
];

const LoginFooter = () => {
  return (
    <Footer className="login-footer">
      <div className="footer-content">
        <Row gutter={[16, 4]} justify="start" className="footer-link-columns">
          {footerData.map((section) => (
            <Col xs={12} sm={12} md={6} key={section.title}>
              <div className="footer-title">{section.title}</div>
              <ul className="footer-links">
                {section.links.map((link) => (
                  <li key={link.text}>
                    <Link href={link.url} target="_blank" rel="noopener noreferrer">
                      {link.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </Col>
          ))}
        </Row>
        <div className="footer-bottom">
          <div className="footer-policy-links">
            <Link href="https://gohire.com/terms-conditions/" target="_blank">Terms & Conditions</Link>
            <span className="separator">|</span>
            <Link href="https://gohire.com/privacy-policy/" target="_blank">Privacy Policy</Link>
            <span className="separator">|</span>
            <Link href="https://gohire.com/tcpa-compliance/" target="_blank">TCPA Compliance</Link>
          </div>
          <Text className="copyright">
            © {new Date().getFullYear()} GoHire Inc. All rights reserved.
          </Text>
        </div>
      </div>
    </Footer>
  );
};

export default LoginFooter;
